import TktIcon from "@mui/icons-material/AirplaneTicket";
import BaseTag from "./BaseTag";

const TktTag = (props) => <BaseTag icon={<TktIcon />} label={props.value} />;

export default TktTag;
